import { ProfilePage } from "apps/batchOnboarding/profile/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(ProfilePage, "BulkProfilePage");
